import { render } from "./Support.vue?vue&type=template&id=0af350d8"
const script = {}

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__